// --------------------------------------------------------------------------------------------------
// <autogenerated>
// <copyright file="TypeScriptUsageTypes.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   This file was generated by the UsageGen tool
// </summary>
// </autogenerated>
// --------------------------------------------------------------------------------------------------
module OSFLog {
  export interface IUsageData {
    SerializeRow(): string;
    Fields: {
      [key: string]: any;
    };
  }
  export interface IUsageLogger {
    LogData(data: IUsageData): void;
  }
  export class BaseUsageData implements IUsageData {
    private _table: string;
    private _fields: {
      [key: string]: any;
    };
    private _serializedFields: {
      [key: string]: string;
    };
    constructor(table: string) {
      this._table = table;
      this._fields = {};
    }
    public get Fields(): {
      [key: string]: any;
    } {
      return this._fields;
    }
    public get Table(): string {
      return this._table;
    }
    public SerializeFields(): void {}
    public SetSerializedField(key: string, value: any) {
      if (typeof value !== "undefined" && value !== null) {
        this._serializedFields[key] = value.toString();
      }
    }
    public SerializeRow(): string {
      this._serializedFields = {};
      this.SetSerializedField("Table", this._table);
      this.SerializeFields();
      return JSON.stringify(this._serializedFields);
    }
  }
  export class AppLoadTimeUsageData extends BaseUsageData {
    constructor() {
      super("AppLoadTime");
    }
    public get CorrelationId(): string {
      return this.Fields["CorrelationId"];
    }
    public set CorrelationId(value: string) {
      this.Fields["CorrelationId"] = value;
    }
    public get AppInfo(): number {
      return this.Fields["AppInfo"];
    }
    public set AppInfo(value: number) {
      this.Fields["AppInfo"] = value;
    }
    public get ActivationInfo(): number {
      return this.Fields["ActivationInfo"];
    }
    public set ActivationInfo(value: number) {
      this.Fields["ActivationInfo"] = value;
    }
    public get InstanceId(): string {
      return this.Fields["InstanceId"];
    }
    public set InstanceId(value: string) {
      this.Fields["InstanceId"] = value;
    }
    public get AssetId(): number {
      return this.Fields["AssetId"];
    }
    public set AssetId(value: number) {
      this.Fields["AssetId"] = value;
    }
    public get Stage1Time(): number {
      return this.Fields["Stage1Time"];
    }
    public set Stage1Time(value: number) {
      this.Fields["Stage1Time"] = value;
    }
    public get Stage2Time(): number {
      return this.Fields["Stage2Time"];
    }
    public set Stage2Time(value: number) {
      this.Fields["Stage2Time"] = value;
    }
    public get Stage3Time(): number {
      return this.Fields["Stage3Time"];
    }
    public set Stage3Time(value: number) {
      this.Fields["Stage3Time"] = value;
    }
    public get Stage4Time(): number {
      return this.Fields["Stage4Time"];
    }
    public set Stage4Time(value: number) {
      this.Fields["Stage4Time"] = value;
    }
    public get Stage5Time(): number {
      return this.Fields["Stage5Time"];
    }
    public set Stage5Time(value: number) {
      this.Fields["Stage5Time"] = value;
    }
    public get Stage6Time(): number {
      return this.Fields["Stage6Time"];
    }
    public set Stage6Time(value: number) {
      this.Fields["Stage6Time"] = value;
    }
    public get Stage7Time(): number {
      return this.Fields["Stage7Time"];
    }
    public set Stage7Time(value: number) {
      this.Fields["Stage7Time"] = value;
    }
    public get Stage8Time(): number {
      return this.Fields["Stage8Time"];
    }
    public set Stage8Time(value: number) {
      this.Fields["Stage8Time"] = value;
    }
    public get Stage9Time(): number {
      return this.Fields["Stage9Time"];
    }
    public set Stage9Time(value: number) {
      this.Fields["Stage9Time"] = value;
    }
    public get Stage10Time(): number {
      return this.Fields["Stage10Time"];
    }
    public set Stage10Time(value: number) {
      this.Fields["Stage10Time"] = value;
    }
    public get Stage11Time(): number {
      return this.Fields["Stage11Time"];
    }
    public set Stage11Time(value: number) {
      this.Fields["Stage11Time"] = value;
    }
    public get ErrorResult(): number {
      return this.Fields["ErrorResult"];
    }
    public set ErrorResult(value: number) {
      this.Fields["ErrorResult"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("CorrelationId", this.CorrelationId);
      this.SetSerializedField("AppInfo", this.AppInfo);
      this.SetSerializedField("ActivationInfo", this.ActivationInfo);
      this.SetSerializedField("InstanceId", this.InstanceId);
      this.SetSerializedField("AssetId", this.AssetId);
      this.SetSerializedField("Stage1Time", this.Stage1Time);
      this.SetSerializedField("Stage2Time", this.Stage2Time);
      this.SetSerializedField("Stage3Time", this.Stage3Time);
      this.SetSerializedField("Stage4Time", this.Stage4Time);
      this.SetSerializedField("Stage5Time", this.Stage5Time);
      this.SetSerializedField("Stage6Time", this.Stage6Time);
      this.SetSerializedField("Stage7Time", this.Stage7Time);
      this.SetSerializedField("Stage8Time", this.Stage8Time);
      this.SetSerializedField("Stage9Time", this.Stage9Time);
      this.SetSerializedField("Stage10Time", this.Stage10Time);
      this.SetSerializedField("Stage11Time", this.Stage11Time);
      this.SetSerializedField("ErrorResult", this.ErrorResult);
    }
  }
  export class AppNotificationUsageData extends BaseUsageData {
    constructor() {
      super("AppNotification");
    }
    public get CorrelationId(): string {
      return this.Fields["CorrelationId"];
    }
    public set CorrelationId(value: string) {
      this.Fields["CorrelationId"] = value;
    }
    public get ErrorResult(): number {
      return this.Fields["ErrorResult"];
    }
    public set ErrorResult(value: number) {
      this.Fields["ErrorResult"] = value;
    }
    public get NotificationClickInfo(): number {
      return this.Fields["NotificationClickInfo"];
    }
    public set NotificationClickInfo(value: number) {
      this.Fields["NotificationClickInfo"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("CorrelationId", this.CorrelationId);
      this.SetSerializedField("ErrorResult", this.ErrorResult);
      this.SetSerializedField("NotificationClickInfo", this.NotificationClickInfo);
    }
  }
  export class AppManagementMenuUsageData extends BaseUsageData {
    constructor() {
      super("AppManagementMenu");
    }
    public get AssetId(): number {
      return this.Fields["AssetId"];
    }
    public set AssetId(value: number) {
      this.Fields["AssetId"] = value;
    }
    public get OperationMetadata(): number {
      return this.Fields["OperationMetadata"];
    }
    public set OperationMetadata(value: number) {
      this.Fields["OperationMetadata"] = value;
    }
    public get ErrorResult(): number {
      return this.Fields["ErrorResult"];
    }
    public set ErrorResult(value: number) {
      this.Fields["ErrorResult"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("AssetId", this.AssetId);
      this.SetSerializedField("OperationMetadata", this.OperationMetadata);
      this.SetSerializedField("ErrorResult", this.ErrorResult);
    }
  }
  export class InsertionDialogSessionUsageData extends BaseUsageData {
    constructor() {
      super("InsertionDialogSession");
    }
    public get AssetId(): number {
      return this.Fields["AssetId"];
    }
    public set AssetId(value: number) {
      this.Fields["AssetId"] = value;
    }
    public get TotalSessionTime(): number {
      return this.Fields["TotalSessionTime"];
    }
    public set TotalSessionTime(value: number) {
      this.Fields["TotalSessionTime"] = value;
    }
    public get TrustPageSessionTime(): number {
      return this.Fields["TrustPageSessionTime"];
    }
    public set TrustPageSessionTime(value: number) {
      this.Fields["TrustPageSessionTime"] = value;
    }
    public get DialogState(): number {
      return this.Fields["DialogState"];
    }
    public set DialogState(value: number) {
      this.Fields["DialogState"] = value;
    }
    public get LastActiveTab(): number {
      return this.Fields["LastActiveTab"];
    }
    public set LastActiveTab(value: number) {
      this.Fields["LastActiveTab"] = value;
    }
    public get LastActiveTabCount(): number {
      return this.Fields["LastActiveTabCount"];
    }
    public set LastActiveTabCount(value: number) {
      this.Fields["LastActiveTabCount"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("AssetId", this.AssetId);
      this.SetSerializedField("TotalSessionTime", this.TotalSessionTime);
      this.SetSerializedField("TrustPageSessionTime", this.TrustPageSessionTime);
      this.SetSerializedField("DialogState", this.DialogState);
      this.SetSerializedField("LastActiveTab", this.LastActiveTab);
      this.SetSerializedField("LastActiveTabCount", this.LastActiveTabCount);
    }
  }
  export class UploadFileDevCatelogUsageData extends BaseUsageData {
    constructor() {
      super("UploadFileDevCatelog");
    }
    public get CorrelationId(): string {
      return this.Fields["CorrelationId"];
    }
    public set CorrelationId(value: string) {
      this.Fields["CorrelationId"] = value;
    }
    public get OperationMetadata(): number {
      return this.Fields["OperationMetadata"];
    }
    public set OperationMetadata(value: number) {
      this.Fields["OperationMetadata"] = value;
    }
    public get ErrorResult(): number {
      return this.Fields["ErrorResult"];
    }
    public set ErrorResult(value: number) {
      this.Fields["ErrorResult"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("CorrelationId", this.CorrelationId);
      this.SetSerializedField("OperationMetadata", this.OperationMetadata);
      this.SetSerializedField("ErrorResult", this.ErrorResult);
    }
  }
  export class UploadFileDevCatalogUsageUsageData extends BaseUsageData {
    constructor() {
      super("UploadFileDevCatalogUsage");
    }
    public get CorrelationId(): string {
      return this.Fields["CorrelationId"];
    }
    public set CorrelationId(value: string) {
      this.Fields["CorrelationId"] = value;
    }
    public get StoreType(): string {
      return this.Fields["StoreType"];
    }
    public set StoreType(value: string) {
      this.Fields["StoreType"] = value;
    }
    public get AppId(): string {
      return this.Fields["AppId"];
    }
    public set AppId(value: string) {
      this.Fields["AppId"] = value;
    }
    public get AppVersion(): string {
      return this.Fields["AppVersion"];
    }
    public set AppVersion(value: string) {
      this.Fields["AppVersion"] = value;
    }
    public get AppTargetType(): number {
      return this.Fields["AppTargetType"];
    }
    public set AppTargetType(value: number) {
      this.Fields["AppTargetType"] = value;
    }
    public get IsAppCommand(): string {
      return this.Fields["IsAppCommand"];
    }
    public set IsAppCommand(value: string) {
      this.Fields["IsAppCommand"] = value;
    }
    public get AppSizeWidth(): number {
      return this.Fields["AppSizeWidth"];
    }
    public set AppSizeWidth(value: number) {
      this.Fields["AppSizeWidth"] = value;
    }
    public get AppSizeHeight(): number {
      return this.Fields["AppSizeHeight"];
    }
    public set AppSizeHeight(value: number) {
      this.Fields["AppSizeHeight"] = value;
    }
    public SerializeFields(): void {
      this.SetSerializedField("CorrelationId", this.CorrelationId);
      this.SetSerializedField("StoreType", this.StoreType);
      this.SetSerializedField("AppId", this.AppId);
      this.SetSerializedField("AppVersion", this.AppVersion);
      this.SetSerializedField("AppTargetType", this.AppTargetType);
      this.SetSerializedField("IsAppCommand", this.IsAppCommand);
      this.SetSerializedField("AppSizeWidth", this.AppSizeWidth);
      this.SetSerializedField("AppSizeHeight", this.AppSizeHeight);
    }
  }
}
